document.documentElement.classList.remove('no-js');

(() => {
  const section = document.querySelector('[data-logo-scroll]');
  if (!section) return;
  const frames = Array.from(section.querySelectorAll('[data-logo-frame]'));
  const bar = section.querySelector('[data-logo-progress]');
  if (!frames.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let ticking = false;
  const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

  function render() {
    ticking = false;
    const rect = section.getBoundingClientRect();
    const scrollable = Math.max(1, section.offsetHeight - window.innerHeight);
    const progress = clamp((-rect.top) / scrollable, 0, 1);
    const framePosition = progress * (frames.length - 1);
    const base = Math.floor(framePosition);
    const mix = framePosition - base;

    frames.forEach((frame, index) => {
      let opacity = 0;
      if (index === base) opacity = 1 - mix;
      if (index === base + 1) opacity = mix;
      if (base === frames.length - 1 && index === base) opacity = 1;
      frame.style.opacity = opacity.toFixed(4);
      frame.style.transform = `scale(${(0.985 + progress * 0.03).toFixed(4)})`;
      frame.classList.toggle('is-active', opacity > 0.001);
    });
    if (bar) bar.style.transform = `scaleX(${progress.toFixed(4)})`;
  }

  function requestRender() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(render);
    }
  }

  window.addEventListener('scroll', requestRender, { passive: true });
  window.addEventListener('resize', requestRender, { passive: true });
  render();
})();
